"use client";
import React, {useState} from "react";
import {
  Box,
  Center,
  Divider,
  Heading,
  SimpleGrid,
  Stack,
  VStack,
  Text,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import {useSectionHeadingVariant} from "@/theme/components/useSectionHeading";
import {PricingGroup} from "../../elements";
import {CONSUMER_GPU_CPU_DATA} from "./constants";

const PRICE_UNIT = {
  HOURLY: "hourly",
  MONTHLY: "monthly",
};

export const DesktopView = ({data, frequency}) => (
  <Box>
    <TableContainer>
      <Table
        variant="striped"
        border="2px solid rgb(237,242,247)"
        width="100%"
        sx={{
          th: {textAlign: "center"},
          td: {textAlign: "center", fontSize: "15px"},
        }}
      >
        <Thead>
          <Tr>
            <Th>CPU</Th>
            <Th>Memory</Th>
            <Th>Base Clock | Boost</Th>
            <Th>Disk</Th>
            <Th>GPU</Th>
            <Th textAlign="center">
              {frequency === PRICE_UNIT.HOURLY ? "Hourly" : "Monthly"} Price (USD)
            </Th>{" "}
          </Tr>
        </Thead>
        <Tbody>
          {data.map((item, index) => (
            <Tr key={index} fontSize={"16px"}>
              <Td>{item.cpu}</Td>
              <Td>{item.memory}</Td>
              <Td>{item.cockBoost}</Td>
              <Td>{item.disk}</Td>
              <Td>{item.gpu}</Td>
              <Td
                textAlign="center"
                fontWeight="700"
                fontSize="18px !important"
                color="primary.200"
              >
                {frequency === PRICE_UNIT.HOURLY
                  ? `$${(item.monthlyPrice / 730).toFixed(2)}`
                  : `$${item.monthlyPrice}`}
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  </Box>
);

export const MobileView = ({data, frequency}) => (
  <SimpleGrid columns={1} spacing={6}>
    {data.map((item, index) => (
      <VStack
        key={index}
        borderRadius="lg"
        borderWidth="1px"
        borderColor="gray.200"
        boxShadow="md"
        spacing={4}
        w="100%"
        p={4}
        bg="white"
      >
        <Text fontWeight="bold" fontSize="lg">
          {item.cpu}
        </Text>

        <Divider borderColor="gray.200" />

        <Stack spacing={2} w="full">
          <Box>
            <Text as="span" fontSize="sm" color="text.100">
              Memory:{" "}
            </Text>
            <Text as="span" fontWeight="medium" fontSize="md">
              {item.memory}
            </Text>
          </Box>
          <Box>
            <Text as="span" fontSize="sm" color="text.100">
              Base Clock | Boost:{" "}
            </Text>
            <Text as="span" fontWeight="medium" fontSize="md">
              {item.cockBoost}
            </Text>
          </Box>
          <Box>
            <Text as="span" fontSize="sm" color="text.100">
              Disk:{" "}
            </Text>
            <Text as="span" fontWeight="medium" fontSize="md">
              {item.disk}
            </Text>
          </Box>
          <Box>
            <Text as="span" fontSize="sm" color="text.100">
              GPU:{" "}
            </Text>
            <Text as="span" fontWeight="medium" fontSize="md">
              {item.gpu}
            </Text>
          </Box>
          <Box>
            <Text as="span" fontSize="sm" color="text.100">
              {frequency === PRICE_UNIT.HOURLY ? "Hourly" : "Monthly"} Price:{" "}
            </Text>
            <Text as="span" fontWeight="bold" fontSize="lg" color="primary.200">
              {frequency === PRICE_UNIT.HOURLY
                ? `$${(item.monthlyPrice / 730).toFixed(2)}`
                : `$${item.monthlyPrice}`}
            </Text>
          </Box>
        </Stack>
      </VStack>
    ))}
  </SimpleGrid>
);

const ConsumerGpuTable = ({showHeading = true}) => {
  const [frequency, setFrequency] = useState(PRICE_UNIT.HOURLY);
  const {title, data} = CONSUMER_GPU_CPU_DATA;
  const HeadingVariant = useSectionHeadingVariant();

  return (
    <Box id="consumer-gpu">
      {showHeading && (
        <Heading variant={HeadingVariant} textAlign="center" mb={8}>
          {title}
        </Heading>
      )}

      <PricingGroup frequency={frequency} onChange={setFrequency} />

      <Center display={{md: "none"}} w="full">
        <MobileView data={data} frequency={frequency} />
      </Center>
      <Box display={{base: "none", md: "block"}}>
        <DesktopView data={data} frequency={frequency} />
      </Box>
    </Box>
  );
};

export default ConsumerGpuTable;
